/**
 * Brauzer hadisələrinin toplanması.
 *
 * MƏQSƏD
 * İstifadəçi «işləmir» deyəndə nə baş verdiyini SORUŞMADAN görmək. Ona görə
 * yalnız xətalar yox, istifadəçinin ADDIMLARI da yazılır — xəta tək başına
 * çox vaxt kifayət etmir, ondan əvvəl nə edildiyi lazım olur.
 *
 * NƏ YAZILMIR
 * Şifrələr, sessiya tokeni, məktub məzmunu. `send()` yalnız ötürülən sahələri
 * göndərir — nə DOM-u, nə forma dəyərlərini oxumur.
 */

const ENDPOINT = '/api/telemetry';

/** Bu səhifə yüklənməsinin şəxsiyyəti — bir seansın addımlarını birləşdirir. */
export const sessionTrace = Math.random().toString(36).slice(2, 10);

let sent = 0;
/** Sonsuz döngə xətası bütün jurnalı doldurmasın. */
const MAX_PER_LOAD = 60;

interface Payload {
  level: 'info' | 'warn' | 'error';
  action: string;
  summary: string;
  requestId?: string;
  detail?: Record<string, unknown>;
}

function send(p: Payload): void {
  if (sent >= MAX_PER_LOAD) return;
  sent++;

  const body = JSON.stringify({
    ...p,
    detail: {
      trace: sessionTrace,
      url: window.location.pathname,
      ...p.detail,
    },
  });

  // `sendBeacon` səhifə bağlananda da çatdırır — `fetch` orada itir.
  if (navigator.sendBeacon) {
    navigator.sendBeacon(ENDPOINT, new Blob([body], { type: 'application/json' }));
    return;
  }
  void fetch(ENDPOINT, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body,
    credentials: 'same-origin',
    keepalive: true,
  }).catch(() => {
    // Telemetriya sınsa da tətbiq davam etməlidir.
  });
}

/** İstifadəçinin addımı — «domen əlavə et düyməsi basıldı» kimi. */
export function step(summary: string, detail?: Record<string, unknown>): void {
  send({ level: 'info', action: 'web.step', summary, ...(detail ? { detail } : {}) });
}

/** Gözlənilən uğursuzluq — API 4xx qaytardı, istifadəçi xəta gördü. */
export function failure(summary: string, detail?: Record<string, unknown>): void {
  send({ level: 'warn', action: 'web.failure', summary, ...(detail ? { detail } : {}) });
}

/**
 * Qlobal tutucular. `main.tsx`-də bir dəfə çağırılır.
 *
 * Bunlar olmasa JS xətası yalnız istifadəçinin konsolunda qalır və biz onu
 * heç vaxt görmürük — bu gün DNS cədvəlindəki səhvi məhz sən əl ilə
 * bildirdiyin üçün öyrəndim.
 */
export function install(): void {
  window.addEventListener('error', (e) => {
    send({
      level: 'error',
      action: 'web.error',
      summary: `JS xətası: ${e.message}`,
      detail: {
        file: e.filename,
        line: e.lineno,
        col: e.colno,
        stack: e.error?.stack?.split('\n').slice(0, 5).join('\n'),
      },
    });
  });

  window.addEventListener('unhandledrejection', (e) => {
    const r = e.reason as { message?: string; stack?: string } | undefined;
    send({
      level: 'error',
      action: 'web.unhandled',
      summary: `Tutulmamış promise xətası: ${r?.message ?? String(e.reason)}`,
      detail: { stack: r?.stack?.split('\n').slice(0, 5).join('\n') },
    });
  });
}
